<template>
  <div>
    <v-toolbar
      v-if="showToolbar"
      class="px-0"
      color="transparent"
      light
      height="36"
      flat
    >
      <v-layout align-center>
        <v-btn
          small
          v-if="filters.length > 0"
          @click="show_all_filters = !show_all_filters"
          :flat="!show_all_filters"
          color="primary"
        >
          <v-icon small class="pr-2">{{
            show_all_filters ? "mdi-aspect-ratio" : "vertical_split"
          }}</v-icon>
          {{ show_all_filters ? "Hide" : "Show" }} advanced filters
        </v-btn>

        <v-chip dark color="amber darken-2" v-show="numberOfActiveFilters()">
          <v-icon small color="white">mdi-filter-variant</v-icon>
          <strong class="white--text">{{
            numberOfActiveFilters() +
            " " +
            pluralize("filter", numberOfActiveFilters()) +
            " active"
          }}</strong>
        </v-chip>
        <v-spacer></v-spacer>
        <slot name="toolbar_actions"></slot>
        <!-- <v-btn small color="error" @click="reset" :disabled="currentFilterStr==''"><v-icon small class="pr-2">cached</v-icon> Reset filters</v-btn> -->
      </v-layout>
    </v-toolbar>
    <v-container fluid pa-2 style="height: 100%;">
      <v-layout row>
        <v-flex shrink pa-1 v-if="!iterator">
          <v-slide-x-transition>
            <v-flex v-show="show_all_filters">
              <v-card
                flat
                class="pa-0"
                style="min-width: 275px; border-right: 1px #ccc solid;"
              >
                <filtersGenerator
                  :filters="filters"
                  @newFiltersValue="updateFilters"
                  v-if="filters.length > 0"
                />
              </v-card>
            </v-flex>
          </v-slide-x-transition>
        </v-flex>
        <v-flex grow pa-1>
          <v-spacer></v-spacer>
          <v-tooltip bottom v-if="exportExcel">
            <exportExcel
              slot="activator"
              v-if="headers && resources"
              button_label
              :filename="
                resourceName.replace(/[^a-z0-9_-]/gi, '').toLowerCase() +
                '.xlsx'
              "
              :sheetsLabels="[
                resourceName.replace(/[^a-z0-9_-]/gi, '').toLowerCase(),
              ]"
              :sheetsData="[exportDataWithHeaders(resources, headers)]"
              :button_as_icon="true"
            ></exportExcel>
            <span>Download this table as an Excel file</span>
          </v-tooltip>

          <v-data-iterator
            v-if="iterator"
            :items="resources"
            :pagination.sync="paginationData"
            :total-items="totalCount"
            :rows-per-page-text="pluralize(camelize(resourceName, ' '), 2)"
            row
            wrap
            :content-tag="iteratorContentTag"
            :content-props="{ 'fill-height': true }"
          >
            <!-- TODO. Disalow ALL items display on paginated data tables ? at least add an alert -->
            <v-progress-linear
              slot="progress"
              color="blue"
              indeterminate
            ></v-progress-linear>
            <template slot="item" slot-scope="props">
              <slot name="myItems" :item="props.item"></slot>
            </template>
            <template slot="no-data">
              <span class="caption">
                <v-icon color="blue" small class="pr-2">info</v-icon>
                {{ noDataMessage }}
              </span>
            </template>
          </v-data-iterator>

          <v-data-table
            v-else
            :headers="headers"
            :items="resources"
            :pagination.sync="paginationData"
            ref="paginatedDataItems"
            :total-items="totalCount"
            :rows-per-page-text="pluralize(camelize(resourceName, ' '), 2)"
          >
            <!-- TODO. Disalow ALL items display on paginated data tables ? at least add an alert -->
            <v-progress-linear
              slot="progress"
              color="blue"
              indeterminate
            ></v-progress-linear>
            <template slot="items" slot-scope="props">
              <slot name="myItems" :item="props.item"></slot>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Your search for "{{ search }}" found no results.</v-alert
            >
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import gql from "graphql-tag";
import filtersGenerator from "../shared/filtersGenerator";
import { mapGetters } from "vuex";
import pluralize from "pluralize";
import exportExcel from "./exportExcel";
export default {
  name: "paginatedTable",
  components: { filtersGenerator, exportExcel },
  props: {
    iteratorContentTag: {
      type: String,
      default: "div",
    },
    exportExcel: {
      type: Boolean,
      default: false,
    },
    showToolbar: {
      type: Boolean,
      default: true,
    },
    headers: {
      type: Array,
      require: true,
    },
    filters: {
      type: Array,
      require: false,
      default: () => [],
    },
    noDataMessage: {
      type: String,
      default: "No data available",
      required: false,
    },
    getter: {
      type: String,
      required: true,
    },
    store: {
      type: String,
      required: true,
    },
    graphqlQuery: {
      type: Object,
      required: true,
    },
    resourceName: {
      type: String,
      required: true,
    },
    searchLabel: {
      type: String,
      required: false,
    },
    iterator: {
      type: Boolean,
      required: false,
      default: false,
    },
    pagination: {
      type: Object,
      require: false,
      default: () => {
        return {
          descending: true,
          rowsPerPage: 25,
          sortBy: "name",
          page: 1,
        };
      },
    },
    externalFilterString: {
      type: String,
      required: false,
      default: "",
    },
    offsetTotal: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      pluralize,
      show_all_filters: false,
      search: "",
      paginationData: {
        descending: true,
        rowsPerPage: 25,
        sortBy: "name",
        page: 1,
      },
      filtersValue: "",
      reqRateLimit: 1000,
      sended: false,
      sendAgain: false
    };
  },
  computed: {
    resources() {
      return this.$store.getters[`${this.store}/${this.getter}`];
    },
    totalCount() {
      return this.$store.getters[`${this.store}/${this.getter}TotalCount`];
    },
  },
  methods: {
    numberOfActiveFilters() {
      let activefilters = 0;
      this.filters.forEach((filter) => {
        if (filter.value) activefilters++;
      });
      return activefilters;
    },
    exportDataWithHeaders(dataset, headers) {
      // remove entries in dataset that aren't part of the headers values.
      let tempArray = [];
      var pick = require("lodash.pick");
      let headers_values = headers.map((h) => h.value);
      dataset.forEach((d) => {
        // remove unwanted columns by using unaltered header.value field,
        // as we can't use a Custom column here to remove those unwanted entries.
        tempArray.push(pick(d, headers_values));
      });
      let ret = tempArray.map((e) => {
        let obj = {};
        headers.map((h) => {
          obj[h.text] = e[h.value];
        });

        return obj;
      });
      return ret;
    },
    camelize(str, sep = "", plural = false) {
      return pluralize(
        str
          .split("_")
          .map((w) => w.replace(/./, (m) => m.toUpperCase()))
          .join(sep),
        plural ? 2 : 1
      );
    },
    getCurrentPage() {
      /* We want to send at most one requet per reqRateLimit */
      if (this.sended) {
        /* A request has been sended less than [reqRateLimit] ms ago */
        this.sendAgain = true;
      } else {
        /* No request sended since reqRateLimit ms */
        this.sendCurrentPageQuery();
        this.sended = true;
        /* In reqRateLimit ms reset boolean and call getCurrentPage if needed */
        setTimeout(() => {
          this.sended = false;
          if (this.sendAgain) {
            this.sendAgain = false;
            this.getCurrentPage();
          }
        }, this.reqRateLimit);
      }
    },
    emitDataTable() {
      this.$emit("refData", this.$refs.paginatedDataItems);
    },
    sendCurrentPageQuery() {
      /* this should not be called from anywhere else than getCurrentPage() */

      var rowsPerPage =
        this.paginationData.rowsPerPage >= 0
          ? this.paginationData.rowsPerPage
          : this.totalCount;
      var sortBy = this.paginationData.sortBy;
      var page = this.paginationData.page;
      var direction = this.paginationData.descending ? "DESC" : "ASC";
      var orderBy = sortBy ? `${sortBy} ${direction}` : "created_at DESC";
      this.subscribe(
        this.graphqlQuery,
        {
          page: page,
          per_page: rowsPerPage,
          order_by: orderBy,
          filter: this.getFilter(),
        },
        this.store,
        this.getter
      );
      // console.log("rowsPerPage",rowsPerPage)
      // console.log("this.totalCount",this.totalCount)
    },
    updateFilters(value) {
      this.filtersValue = value;
      this.paginationData.page = 1;
      this.getCurrentPage();
    },
    getFilter() {
      if (this.externalFilterString && this.filtersValue)
        return `${this.externalFilterString} && ${this.filtersValue}`;
      return this.externalFilterString + this.filtersValue;
    },
  },
  created() {
    /* Use a copy of props value to avoid mutating a props */
    var fields = ["descending", "rowsPerPage", "sortBy", "page"];
    for (var i = 0; i < fields.length; i++)
      if (this.pagination[fields[i]])
        this.paginationData[fields[i]] = this.pagination[fields[i]];

  },
  mounted() {
    this.$watch(() => { return this.$refs.paginatedDataItems && this.$refs.paginatedDataItems.filteredItems },
      (val) => { this.$emit("refData", this.$refs.paginatedDataItems && this.$refs.paginatedDataItems.filteredItems); })
  },
  beforeDestroy() {
    this.unsubscribe(this.getter);
  },
  watch: {
    paginationData() {
      this.getCurrentPage();
    },
    externalFilterString() {
      this.paginationData.page = 1;
      this.getCurrentPage();
    },
  },
};
</script>
